import axios from "axios";

const editSalesitemById = async (token, salesId, item) => {
  item.closingStock = parseInt(item.closingStock);
  item.numberFreebies = parseInt(item.numberFreebies);
  item.numberPaypal = parseInt(item.numberPaypal);
  item.openingStock = parseInt(item.openingStock);
  console.log("Update item", item);
  const path = `${process.env.REACT_APP_BACKEND_API_URL}/sales/${salesId}`;

  try {
    const response = await axios.put(path, item, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
    return response;
  } catch (error) {
    console.log(error.response);
    return error.response;
  } 
};

export default editSalesitemById;